// @ts-ignore
export function debugLogForms(...args) {
  console.log('[lead-forms-ui]', ...args)
}
